/**
 * PUTs the bytes straight to the presigned bucket URL, reporting progress from 0 to 1. Plain XHR on
 * purpose: axios would add the API's bearer token, which must never travel to the bucket, and fetch
 * reports no upload progress. The content type must match the one the URL was signed for.
 */
export const putWithProgress = (
  url: string,
  body: Blob,
  contentType: string,
  onProgress: (fraction: number) => void,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open("PUT", url);
    request.setRequestHeader("Content-Type", contentType);
    request.upload.onprogress = (event) => {
      if (event.lengthComputable) onProgress(event.loaded / event.total);
    };
    request.onload = () =>
      request.status >= 200 && request.status < 300
        ? resolve()
        : reject(new Error(`Upload refused (${request.status})`));
    request.onerror = () => reject(new Error("Upload failed"));
    request.send(body);
  });
